module.exports = __webpack_public_path__ + "static/media/Pin-Light-Policial.ea9e0516.svg";